export default __webpack_public_path__ + "static/media/churchillClosed.3df8c3da.jpg";